var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBoxDelivery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1114 6.46795L14.6114 2.34295C14.5007 2.28205 14.3764 2.25012 14.25 2.25012C14.1236 2.25012 13.9993 2.28205 13.8886 2.34295L6.38857 6.46795C6.27098 6.5327 6.17293 6.62781 6.10463 6.74338C6.03634 6.85894 6.00031 6.99072 6.00031 7.12495C6.00031 7.25919 6.03634 7.39096 6.10463 7.50653C6.17293 7.62209 6.27098 7.71721 6.38857 7.78195L13.5 11.6934V19.7314L11.2228 18.4794L10.5 19.7934L13.8886 21.657C13.9993 21.718 14.1236 21.75 14.25 21.75C14.3764 21.75 14.5007 21.718 14.6114 21.657L22.1114 17.532C22.2291 17.4672 22.3272 17.3721 22.3955 17.2566C22.4639 17.141 22.5 17.0092 22.5 16.875V7.12495C22.5 6.99069 22.4639 6.85889 22.3955 6.74332C22.3272 6.62776 22.2291 6.53266 22.1114 6.46795ZM14.25 3.85615L20.1936 7.12495L14.25 10.3938L8.3064 7.12495L14.25 3.85615ZM21 16.4315L15 19.7315V11.6934L21 8.39343V16.4315Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12H7.5V10.5H1.5V12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H9V16.5H3V18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15H10.5V13.5H4.5V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxDelivery);
export default __webpack_public_path__ + "static/media/ic-box-delivery.724519512761a5d65d360ffb215f9d9d.svg";
export { ForwardRef as ReactComponent };